import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import './p2p.css';

const P2pSidebar = ({ isOpen, onClose, isCollapsed = false, onToggleCollapse }) => {
  const location = useLocation();

  const menuItems = [
    {
      path: '/p2p-dashboard',
      label: 'Dashboard',
      icon: (
        <img src="/images/p2p/Dashboardp2p.svg" alt="Dashboard" />
      ),
    },
    {
      path: '/p2p-create-post',
      label: 'Add post',
      icon: (
        <img src="/images/p2p/Add-post.svg" alt="Add post" />
      ),
    },
    {
      path: '/p2p-my-ads',
      label: 'My Ads',
      icon: (
        <img src="/images/p2p/my-ads.svg" alt="My Ads" />
      ),
    },
    {
      path: '/p2p-orders',
      label: 'P2P Orders',
      icon: (
        <img src="/images/p2p/p2p-orders.svg" alt="P2P Orders" />
      ),
    },
    {
      path: '/p2p-profile',
      label: 'Profile',
      icon: (
        <img src="/images/p2p/profilep2p.svg" alt="Profile" />
      ),
    },
  ];

  const isActive = (path, hash) => {
    if (hash) {
      return location.pathname === path && location.hash === hash;
    }
    return location.pathname === path && !location.hash;
  };

  return (
    <>
      {/* Overlay for mobile */}
      <div
        className={`p2p-sidebar-overlay ${isOpen ? 'p2p-visible' : ''}`}
        onClick={onClose}
      />

      <aside className={`p2p-sidebar ${isOpen ? 'p2p-open' : ''} ${isCollapsed ? 'p2p-sidebar--collapsed' : ''}`}>
        <button className="p2p-sidebar-close" onClick={onClose}>
          ×
        </button>

        {/* Collapse toggle button on the rail edge (identical to Dashboard page) */}
        <button
          type="button"
          className="p2p-sidebar-collapse-btn"
          onClick={onToggleCollapse}
          aria-expanded={!isCollapsed}
          aria-label={isCollapsed ? "Expand navigation" : "Collapse navigation"}
          title={isCollapsed ? "Expand navigation" : "Collapse navigation"}
        >
          <i className={isCollapsed ? "ri-arrow-right-s-line" : "ri-arrow-left-s-line"} aria-hidden="true" />
        </button>

        <nav className="p2p-sidebar-nav mt-5">
          {menuItems.map((item, index) => (
            <NavLink
              key={index}
              to={item.hash ? `${item.path}${item.hash}` : item.path}
              end
              className={() =>
                `p2p-nav-item ${isActive(item.path, item.hash) ? 'active' : ''}`
              }
              onClick={onClose}
              title={isCollapsed ? item.label : undefined}
            >
              <span className="p2p-nav-icon">{item.icon}</span>
              <span className="p2p-nav-label">{item.label}</span>
            </NavLink>
          ))}
        </nav>

        <div className="p2p-sidebar-footer">
          <a href="/" className="p2p-back-link" title={isCollapsed ? "Back to Exchange" : undefined}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M19 12H5M12 19l-7-7 7-7" />
            </svg>
            <span className="p2p-back-link-text">Back to Exchange</span>
          </a>
        </div>
      </aside>
    </>
  );
};

export default P2pSidebar;
